import axios from "../../department-viags/config.service";

export type RolePermissions = {
  id: number;
  roleId: number;
  permissionId: number;
  roleName: string;
  permissionName: string;
  permissionCode: string;
  c: boolean;
  r: boolean;
  u: boolean;
  d: boolean;
  description: string;
  note: string;
};

export type EmployeeRoleParams = {
  email: string;
  roleId: number;
  description: string;
  note: string;
  id?: number;
  createdDate?: string;
};

export type EmployeeRole = {
  id: number;
  roleName: string;
  description: string;
  note: string;
  numOfUpdate: number;
  rolePermissions: RolePermissions[];
};

export type EmployeeConfigType = {
  id: number;
  email: string;
  name: string;
  note: string;
  createdDate: string;
  updatedDate: string;
};

export class EmployeeRoleService {
  static async getList(employeeCode: string) {
    try {
      const res = await axios.get<{ data: EmployeeRole; statusCode: number }>("/employeerole/get-role-of-employee", {
        params: { employeeCode: employeeCode },
      });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async getListByRoleId(roleId: number) {
    const res = await axios.get<{ data: EmployeeConfigType[]; statusCode: number }>(
      "employeerole/get-list-employee-by-role",
      { params: { roleId: roleId } },
    );
    return res.data.data;
  }

  static async checkEmployeeHavePermission(email: string, permissionCode: string, type?: number) {
    const highPiority = ["thiennv@viags.vn", "canbo1@viags.vn", "canbo2@viags.vn", "botit@viags.vn"];

    if (permissionCode === "14") {
      if (highPiority.includes(email?.toLocaleLowerCase())) return true;
      else return false;
    }

    const res = await axios.get<{ data: Boolean; statusCode: number }>("employeerole/check-empl-have-permission", {
      params: { email: email, permissionCode: permissionCode, type: type },
    });
    return res.data.data;
  }

  static async addEmployeeRole(fields: EmployeeRoleParams) {
    try {
      const res = await axios.post("/employeerole/create", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updateEmployeeRole(fields: EmployeeRoleParams) {
    try {
      const res = await axios.post("/employeerole/update", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async deleteEmployeeRole(id: number) {
    try {
      const res = await axios.delete(`/employeerole/delete/${id}`);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }
}
